"use client";

import React from "react";
import { ArrowRight, ChevronRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Cta() {
  const shouldReduceMotion = useReducedMotion();
  return;
}